import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var item = /*#__PURE__*/css(["padding:0 ", "px;flex:1 1 0;text-align:center;", ""], spacing.xs, mediaQuery({
  min: minBreakpoints.L
}, css(["padding:0;width:", "px;"], spacing.lg * 4)));
export var getVisibleBelowBreakpointStyles = function getVisibleBelowBreakpointStyles(breakpoint) {
  return breakpoint ? css(["", ""], mediaQuery({
    min: minBreakpoints[breakpoint]
  }, css(["display:none;"]))) : '';
};
export var getVisibleAboveBreakpointStyles = function getVisibleAboveBreakpointStyles(breakpoint) {
  return breakpoint ? css(["", ""], mediaQuery({
    max: maxBreakpoints[breakpoint]
  }, css(["display:none;"]))) : '';
};
export var label = /*#__PURE__*/css(["display:none;", ""], mediaQuery({
  min: minBreakpoints.L
}, css(["display:block;"])));